import React, { useState } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../../store/Actions/actions";
import cloneDeep from "lodash.clonedeep";

//flimp
import * as UTILS from "../../../../utils/Utils";

//Accordion
import "../Accordion.scss";
import AccordionWrapper from "../AccordionWrapper";
import AccordionSettings from "../AccordionSettings";
import NestedAccordionItem from "./NestedAccordionItem";


const NestedAccordion = (props) => {
    const [accordionSettings, setAccordionSettings] = useState(false);
    const [openAccordionItems, setOpenAccordionItems] = useState([]);
    const [openAccordionItemSettingsIndex, setOpenAccordionItemSettingsIndex] =
        useState(null);

    var indexInitial = [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    ];
    indexInitial = indexInitial.filter(
        (index) => !Object.keys(props.element.columns).includes(`c${index}`)
    );
    const [indices, setIndices] = useState(indexInitial);

    const toggleAccordionItemSettings = (index) => {
        setOpenAccordionItemSettingsIndex(index);
        setOpenAccordionItems([index]);
        setAccordionSettings(false);
    };

    const openAndCloseAccordionItems = (itemIndex) => {
        let newItems = openAccordionItems;
        if (props.mobileView) {
            if (props.element.accordion.mobileStyle.multiItemExpand == true) {
                if (newItems.includes(itemIndex)) {
                    setOpenAccordionItems((openAccordionItems) =>
                        openAccordionItems.filter((item, index) => item != itemIndex)
                    );
                } else {
                    setOpenAccordionItems((openAccordionItems) => [
                        ...openAccordionItems,
                        itemIndex,
                    ]);
                }
            } else {
                if (newItems.includes(itemIndex)) {
                    setOpenAccordionItems([]);
                } else {
                    setOpenAccordionItems([itemIndex]);
                }
            }
        } else if (!props.mobileView) {
            if (props.element.accordion.desktopStyle.multiItemExpand == true) {
                if (newItems.includes(itemIndex)) {
                    setOpenAccordionItems((openAccordionItems) =>
                        openAccordionItems.filter((item, index) => item != itemIndex)
                    );
                } else {
                    setOpenAccordionItems((openAccordionItems) => [
                        ...openAccordionItems,
                        itemIndex,
                    ]);
                }
            } else {
                if (newItems.includes(itemIndex)) {
                    setOpenAccordionItems([]);
                } else {
                    setOpenAccordionItems([itemIndex]);
                }
            }
        }
    };

    const toggleAccordionSettings = () => {
        setAccordionSettings(!accordionSettings);
    };

    const addColumn = () => {
        if (indices == []) return;

        var lastIndex = Object.keys(props.element.columns)[
            Object.keys(props.element.columns).length - 1
        ];
        var randomKey = `c${indices[Math.round(Math.random() * (indices.length - 1))]
            }`;

        setIndices(indices.filter((item) => item != randomKey.split("c")[1]));

        let layout = cloneDeep(props.layout);

        const newLayout = UTILS.UpdateLayout(
            layout,
            props.ID,
            (item) => {
                item.columns[randomKey] = [];
                item.columnSettings[randomKey] = {
                    ...props.element.columnSettings[lastIndex],
                    itemHeader: {
                        ...props.element.columnSettings[lastIndex].itemHeader,
                        title: `Copy of ${props.element.columnSettings[lastIndex].itemHeader.title}`,
                    },
                };
            },
            (colItem) => {
                colItem.columns[randomKey] = [];
                colItem.columnSettings[randomKey] = {
                    ...props.element.columnSettings[lastIndex],
                    itemHeader: {
                        ...props.element.columnSettings[lastIndex].itemHeader,
                        title: `Copy of ${props.element.columnSettings[lastIndex].itemHeader.title}`,
                    },
                };
            }
        );
        props.layoutArray(props.layoutTitle, newLayout);
    };

    const duplicateColumn = (itemIndex) => {
        if (indices == []) return;
        var randomKey = `c${indices[Math.round(Math.random() * (indices.length - 1))]
            }`;
        setIndices(indices.filter((item) => item != randomKey.split("c")[1]));
        var columnLength = Object.keys(props.element.columns).length;

        let layout = cloneDeep(props.layout);
        const newLayout = UTILS.UpdateLayout(
            layout,
            props.ID,
            (item) => {
                item.columns[randomKey] = UTILS.PushWithID(
                    cloneDeep(item.columns[itemIndex])
                );
                item.columnSettings[randomKey] = {
                    ...props.element.columnSettings[itemIndex],
                    itemHeader: {
                        ...props.element.columnSettings[itemIndex].itemHeader,
                        title: `Copy of ${props.element.columnSettings[itemIndex].itemHeader.title}`,
                    },
                };
            },
            (colItem) => {
                colItem.columns[randomKey] = UTILS.PushWithID(
                    cloneDeep(colItem.columns[itemIndex])
                );
                colItem.columnSettings[randomKey] = {
                    ...props.element.columnSettings[itemIndex],
                    itemHeader: {
                        ...props.element.columnSettings[itemIndex].itemHeader,
                        title: `Copy of ${props.element.columnSettings[itemIndex].itemHeader.title}`,
                    },
                };
            }
        );
        props.layoutArray(props.layoutTitle, newLayout);
    };

    const removeColumn = () => {
        if (indices.length == 20) return;

        var removeKey = Object.keys(props.element.columns)[
            Object.keys(props.element.columns).length - 1
        ];

        setIndices([...indices, Number(removeKey.split("c")[1])]);

        var element = props.element;
        delete element.columns[removeKey];
        delete element.columnSettings[removeKey];
        let layout = cloneDeep(props.layout);
        const newLayout = UTILS.UpdateLayout(
            layout,
            props.ID,
            (item) => {
                item = element;
            },
            (colItem) => {
                colItem = element;
            }
        );
        props.layoutArray(props.layoutTitle, newLayout);
    };

    const removeSpecificColumn = (itemKey) => {
        if (indices.length == 20) return;

        setIndices([...indices, Number(itemKey.split("c")[1])]);

        var element = props.element;
        delete element.columns[itemKey];
        delete element.columnSettings[itemKey];

        const newLayout = UTILS.UpdateLayout(
            props.layout,
            props.ID,
            (item) => {
                item = element;
            },
            (colItem) => {
                colItem = element;
            }
        );
        props.layoutArray(props.layoutTitle, newLayout);
    };
    const dropContainerWidth =
        document.getElementsByClassName("dropContainer")[0] &&
        document.getElementsByClassName("dropContainer")[0].offsetWidth;
    return (
        <AccordionWrapper mobileView={props.mobileView} element={props.element}>
            <div className="accordionActionControl">
                <button
                    onClick={toggleAccordionSettings}
                    title="Settings"
                    className="setting-column"
                >
                    <small>Setting</small>
                </button>
                <button
                    onClick={() => props.cloneElement(props.ID)}
                    className="clone-item"
                ></button>

                <>
                    <div className="addRemoveWrapper">
                        {
                            <span
                                onClick={addColumn}
                                title="Add Column"
                                className="addColumn"
                            >
                                +
                            </span>
                        }
                        {Object.keys(props.element.columns).length >= 2 ? (
                            <span
                                onClick={removeColumn}
                                title="Remove Column"
                                className="removeColumn"
                            >
                                -
                            </span>
                        ) : (
                            ""
                        )}
                    </div>
                </>

                <span
                    className="delete-item"
                    onClick={() => props.deleteElement(props.ID)}
                >
                    <i className="far fa-trash-alt" />
                </span>
            </div>
            {accordionSettings ? (
                <AccordionSettings
                    toggleAccordionItemSettings={toggleAccordionItemSettings}
                    openAccordionItemSettingsIndex={openAccordionItemSettingsIndex}
                    closePopup={toggleAccordionSettings}
                    element={props.element}
                    columns={props.element.columns}
                    removeSpecificColumn={removeSpecificColumn}
                    duplicateColumn={duplicateColumn}
                ></AccordionSettings>
            ) : (
                ""
            )}

            {Object.keys(props.element.columns).map((col, colIndex) => {
                return (
                    <NestedAccordionItem
                        addRemoveColumn={props.addRemoveColumn}
                        mobileView={props.mobileView}
                        userId={props.userID}
                        sessionId={props.sessionID}
                        key={"accordionItem" + colIndex}
                        selectedFont={props.selectedFont}
                        element={props.element}
                        col={col}
                        columns={props.element.columns}
                        colIndex={colIndex}
                        ID={props.ID}
                        disableRowTool={props.disableRowTool}
                        showAddElement={props.showAddElement}
                        tool={props.tool}
                        onAddElementorColumnInColumn={props.onAddElementorColumnInColumn}
                        onAddElementorColumn={props.onAddElementorColumn}
                        pagesList={props.pagesList}
                        preset={props.preset}
                        cloneElement={props.cloneElement}
                        deleteElement={ props.deleteElement}
                        openAndCloseAccordionItems={openAndCloseAccordionItems}
                        openAccordionItems={openAccordionItems}
                        toggleAccordionItemSettings={toggleAccordionItemSettings}
                        openAccordionItemSettingsIndex={openAccordionItemSettingsIndex}
                        parent={{data:''}}
                    />
                );
            })}
        </AccordionWrapper>
    );
};

const mapStateToProps = (state) => {
    return {
        layout: state.present.layout,
        layoutTitle: state.present.layoutTitle,
        canvasStyle: state.present.canvasStyle,
        elementsFont: state.present.canvasStyle.elementsFont,
        columnGap: state.present.canvasStyle.columnGap,
        canvasRowsPaddingUnit: state.present.canvasStyle.canvasRowsPaddingUnit,
        enableWidthForRow: state.present.enableWidthForRow,
        canvasRowsPadding: state.present.canvasStyle.canvasRowsPadding,
        containerWidth: state.present.containerWidth,
        canvasRowsPaddingMobile: state.present.canvasStyle.canvasRowsPaddingMobile,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        layoutArray: (titleValue, layoutVal) =>
            dispatch(
                actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
            ),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(NestedAccordion);
